/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */

/**
 * Etiology type name (multilingual)
 */
export type EtiologyTypeDtoName = { [key: string]: string };
